import { CreateTicketPayload } from './useCreateTicket.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';
import { Ticket } from 'modules/IMC/MessageCenter/components/MessageCenterContent/MessageList/MessageList.interface';

const createTicket = async (payload: CreateTicketPayload) => {
    try {
        const responseData = await zendeskGateway.post<{ ticket: Ticket }>(`/tickets`, payload);
        return responseData?.data?.ticket;
    } catch (error) {
        sendDatadogRumError('createTicket', error, { source: 'createTicket', payload });
        throw error;
    }
};

export default createTicket;
